import { user } from '@/common/service/ApiList';
import ServiceExec from '@/common/utils/ServiceExec';
const { changeLocale } = user;

export const state = {
  locale: ''
};

export const actions = {
  translateBubble: async ({ commit }, payload) => {
    const response = await ServiceExec.get('/common/translate/bubble', { ...payload }, { responseType: 'text' });
    if (response.status !== 200) return false;
    if (typeof response.data === 'number') return response.data;

    let txt = response.data;
    txt = txt.replaceAll('&amp;', '&');
    txt = txt.replaceAll('&quot;', '"');
    txt = txt.replaceAll('＆lt;', '<');
    txt = txt.replaceAll('＆gt;', '>');
    txt = txt.replaceAll('＆nbsp;', ' ');
    txt = txt.replaceAll('&#039;', "'");
    txt = txt.replaceAll('&#39;', "'");
    txt = txt.replaceAll('&#035;', '#');
    return txt;
  },

  setLocale({ commit, rootGetters }, locale = 'ko') {
    commit('setLocale', locale);

    let serverLocale = locale === 'ko' ? 'KO' : locale === 'vn' ? 'VN' : 'EN';
    const { userNo } = rootGetters['user/getUserData'];
    let result = false;
    if (!!userNo) result = ServiceExec.patch(changeLocale(userNo, serverLocale));

    return result;
  }
};
export const mutations = {
  setLocale(state, locale = 'ko') {
    state.locale = locale;
  }
};

export const getters = {
  getLocale: (state) => state.locale
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
